<template>
  <div>
    <b-container fluid>
      <!-- <h3 class="mt-3 mb-3">Route Allocation</h3> -->
      <b-row>
        <b-col cols="3">
          <h3 class="mt-3 mb-3">External Route Allocation</h3>
        </b-col>
        <b-col cols="2" style="display: flex; align-items:center;">
          <b-form-select size="lg" v-model="search_criteria.show_history_record" :options="history_record_option"
            @change="onChangeShowHistoryRecord" style="align-self: center">
            Show History Record
          </b-form-select>
        </b-col>
        <b-col cols="4" style="display: flex; align-items:center;">

          <b-form-input id="input-small" size="lg" type="date" v-model="search_criteria.scheduled_delivery_date"
            :disabled="search_criteria.show_history_record == 'show_history_record'"></b-form-input>
          <b-button size="lg" variant="info" @click="onSearch">
            <font-awesome-icon class="mr-1" icon="sync" />
          </b-button>
        </b-col>
      </b-row>

      <b-card class="mb-1" v-if="$store.state.user_obj.account_type != 'driver_route'">
        <b-row>
          <b-col cols="2" class="pr-1">
            <b-form-select size="sm" v-model="update_route_obj.courier" :options="cart_courier_options" />
          </b-col>
          <b-col cols="3" class="pl-0 pr-1">
            <b-form-input ref="txt_order_number" size="sm" type="text" placeholder="Tracking#"
              v-model="update_route_obj.tracking_number" v-on:keyup.enter="updateRoute()"></b-form-input>
          </b-col>
          <b-col cols="2" class="text-left p-0">
            <b-button class="btn-action" size="sm" variant="danger" @click="updateRoute">
              Add to Cart
            </b-button>
          </b-col>
          <b-col class="p-0 d-flex align-items-center">
            <b-badge variant="primary" class="mr-2">Queue: {{ submitQueue.length }}</b-badge>
            <b-badge v-if="lastResultText" :variant="lastResultVariant">{{ lastResultText }}</b-badge>
          </b-col>


          <b-col class="p-0">
            <b-button class="btn-action" size="sm" variant="info" @click="removeRoute">
              Remove From Cart
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mt-2" v-if="resultsLog.length">
          <b-col cols="5">
            <b-list-group flush>
              <b-list-group-item v-for="(r, i) in recentResults" :key="r.at || i"
                :variant="r.status === 'success' ? 'success' : (r.status === 'duplicate' ? 'warning' : 'danger')">
                {{ r.tn }} — {{ r.message }}
              </b-list-group-item>
            </b-list-group>
          </b-col>
        </b-row>
      </b-card>

      <div class="search_bar mb-1">
        <b-card>
          <!-- <b-row class="mb-1">
            <b-col cols="2" class="pr-1">
              <b-form-select
                size="sm"
                v-model="search_criteria.channel_selected"
                :options="channel_options"
              />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select
                size="sm"
                v-model="search_criteria.order_status_selected"
                :options="order_status_options"
              />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select
                size="sm"
                v-model="search_criteria.stock_status_selected"
                :options="stock_status_options"
              />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select
                size="sm"
                v-model="search_criteria.fulfilment_status_selected"
                :options="fulfilment_status_options"
              />
            </b-col>
          </b-row> -->
          <b-row>
            <b-col cols="2" class=" pr-1">
              <b-form-select size="sm" v-model="search_criteria.client_selected" multiple :options="client_options" />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select size="sm" v-model="search_criteria.courier_selected" :options="courier_options" />
            </b-col>
            <!-- <b-col cols="2" class="pl-0 pr-1">
              <b-form-select
                size="sm"
                v-model="search_criteria.route_selected"
                :options="search_tracking_route_options"
              />
            </b-col> -->
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select size="sm" v-model="search_criteria.tracking_status_selected"
                :options="tracking_status_options" />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select size="sm" v-model="search_criteria.cart_status_selected" :options="cart_status_options" />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select size="sm" v-model="search_criteria.inout_warehouse" :options="inout_warehouse_options" />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select size="sm" v-model="search_criteria.dncn_status_selected" :options="dncn_status_options" />
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="3" class="pr-1">
              <b-form-input id="input-small" size="sm" type="text" placeholder="Order#/Tracking#"
                v-model="search_criteria.keyword" @keyup.enter="onSearch"></b-form-input>
            </b-col>
            <!-- <b-col cols="2" class="pl-0 pr-1">
              <b-form-input
                id="input-small"
                size="sm"
                type="date"
                v-model="search_criteria.start_at"
              ></b-form-input>
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-input
                id="input-small"
                size="sm"
                type="date"
                v-model="search_criteria.end_at"
              ></b-form-input>
            </b-col> -->
            <b-col class="text-left p-0">
              <b-button class="btn-action" size="sm" variant="info" @click="onSearch">
                <font-awesome-icon class="mr-1" icon="search" />Search
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </div>

      <div class="search_bar mb-3">
        <b-card>
          <div style="margin-bottom: 19px">
            <b-form-checkbox v-model="carton_cnt_checked" name="check-button" switch>
              Show Carton Count
            </b-form-checkbox>
          </div>
          <b-row :key="gi" v-for="(group_no, gi) in (carton_cnt_checked == true ? route_ctns_counts : route_counts)">
            <b-col class="mt-1" cols="2" :key="ri" v-for="(route_count, ri) in (group_no)">
              <div class="cusor_pointer route_box">
                <strong>
                  {{ ri }}
                </strong>
                <div class="row-status_cnt" @click="onSearchByCourier('pending', ri)">
                  <div style="width: 90px;">Pending</div>
                  <div>
                    <span class="dot_red"></span>
                    <span>
                      {{ route_count["pending"] }}
                    </span>
                  </div>
                </div>

                <div class="row-status_cnt" @click="onSearchByCourier('reserved', ri)">
                  <div style="width: 90px;">Reserved</div>
                  <div>
                    <span class="dot_yellow"></span>
                    <span>
                      {{ route_count["reserved"] }}
                    </span>
                  </div>
                </div>

                <div class="row-status_cnt" @click="onSearchByCourier('on_cart', ri)">
                  <div style="width: 90px;">On Cart</div>
                  <div>
                    <span class="dot_green"></span>
                    <span>
                      {{ route_count["on_cart"] }}/{{
                        parseInt(route_count["on_cart"]) +
                        parseInt(route_count["reserved"])
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <hr />

          <b-row class="mt-1 mb-1" v-if="$store.state.user_obj.account_type != 'driver_route'">
            <b-col class="">
              <b-button class="btn-action" size="sm" variant="info" @click="onBulkAction('reserved')">
                Bulk Reserve
              </b-button>

              <b-button class="btn-action" size="sm" variant="info" @click="onBulkAction('pending')">
                Bulk Un-Reserve
              </b-button>

              <b-button class="btn-action" size="sm" variant="info" @click="onBulkShippedExt()">
                Bulk Shipped_Ext
              </b-button>

              <b-button class="btn-action" size="sm" variant="info" @click="bulkDownloadDNCN()">
                Download DNCN
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </div>

      <strong># of Records: {{ total_rows }}</strong>

      <b-row class="mb-1">
        <b-col cols="1" class="pr-0">
          <b-form-select size="sm" v-model="sel_table_limit" :options="[50, 100, 200, 500, 1000]"
            @change="getRouteAllocations()" />
        </b-col>
        <b-col class="pl-0 pr-1">
          <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="sel_table_limit"
            @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>
        </b-col>
      </b-row>

      <b-table responsive small outlined striped hover :items="items" :fields="fields" :tbody-tr-class="rowClass">
        <template v-slot:head(chk_box)="data">
          <b-form-checkbox size="sm" plain id="chkbox_all" value="all" v-model="check_all_rows"></b-form-checkbox>
        </template>
        <template v-slot:cell(chk_box)="data">
          <b-form-checkbox size="sm" class="chkbox_row" plain :id="'chkbox_row_' + data.index"
            v-model="data.item.is_checked"></b-form-checkbox>
        </template>

        <template v-slot:cell(schedule_date)="data">
          {{ displayDate(data.item.schedule_date) }}
        </template>

        <template v-slot:cell(order_number)="data">
          <router-link :to="{
            name: 'order_master_detail',
            params: { order_master_id: data.item.id }
          }" v-if="$store.state.user_obj.account_type != 'driver_route'">
            {{ data.item.order_number }}
          </router-link>

          <div v-if="$store.state.user_obj.account_type == 'driver_route'">
            {{ data.item.order_number }}
          </div>
        </template>

        <!-- <template v-slot:cell(payment_status)="data">
          -
        </template> -->

        <template v-slot:cell(order_import_status)="data">
          <div>
            <span class="span-status">{{ data.item.order_import_status }}</span>

            <span v-if="data.item.order_import_status == 'cancel'" class="dot_red"></span>
            <span v-if="data.item.order_import_status == 'hold'" class="dot_red"></span>
            <span v-if="data.item.order_import_status == 'pending'" class="dot_yellow"></span>
            <span v-if="data.item.order_import_status == 'received'" class="dot_green"></span>
          </div>
        </template>

        <template v-slot:cell(stock_status)="data">
          <div>
            <span class="span-status">{{ data.item.stock_status }}</span>

            <span v-if="data.item.stock_status == '-'" class="dot_white"></span>
            <span v-if="data.item.stock_status == 'pending'" class="dot_red"></span>
            <span v-if="data.item.stock_status == 'available'" class="dot_yellow"></span>
            <span v-if="data.item.stock_status == 'committed'" class="dot_green"></span>
          </div>
        </template>

        <template v-slot:cell(cart)="data">
          <div>
            <span v-if="data.item.cart">{{ data.item.cart }}</span>
            <span v-if="!data.item.cart">-</span>
          </div>
        </template>

        <template v-slot:cell(fulfilment_status)="data">
          <div>
            <span class="span-status">{{ data.item.fulfilment_status }}</span>

            <span v-if="data.item.fulfilment_status == '-'" class="dot_white"></span>
            <span v-if="data.item.fulfilment_status == 'pending'" class="dot_yellow"></span>
            <span v-if="data.item.fulfilment_status == 'completed'" class="dot_green"></span>
            <span v-if="data.item.fulfilment_status == 'fulfiled'" class="dot_green"></span>
          </div>
        </template>

        <template v-slot:cell(cart_status)="data">
          <div>
            <span v-if="data.item.cart_status == 'pending'" class="dot_red"></span>
            <span v-if="data.item.cart_status == 'reserved'" class="dot_yellow"></span>
            <span v-if="data.item.cart_status == 'on_cart'" class="dot_green"></span>
            <span v-if="data.item.cart_status == 'shipped'" class="dot_white"></span>

            <span>{{ data.item.cart_status }}</span>
          </div>
        </template>

        <template v-slot:cell(action)="data">
          <b-button v-if="$store.state.user_obj.account_type != 'driver_route'" class="btn-action" size="sm"
            variant="danger" :disabled="data.item.order_import_status == 'cancel'"
            @click="cancelRoute(data.item)">Cancel</b-button>
        </template>

        <template v-slot:cell(order_date)="data">
          {{ displayDate(data.item.order_date) }}
        </template>

        <template v-slot:cell(scheduled_delivery_date)="data">
          {{ displayDate(data.item.scheduled_delivery_date) }}
        </template>
      </b-table>

      <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="sel_table_limit"
        @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";
import apiService from "../services/ApiService";

const fields = [
  {
    key: "chk_box",
    label: ""
  },
  {
    key: "order_date",
    label: "Order Date"
  },
  {
    key: "scheduled_delivery_date",
    label: "Schedule Delivery"
  },
  {
    key: "client_name",
    label: "Client"
  },
  {
    key: "courier_short_name",
    label: "Courier"
  },
  {
    key: "order_number",
    label: "Order#"
  },
  {
    key: "tracking_number",
    label: "Tracking#"
  },
  {
    key: "ctns",
    label: "Cartons",
    class: "center_align"
  },
  {
    key: "cart_status",
    label: "Cart Status",
    class: " center_align"
  },
  {
    key: "courier_short_name",
    label: "Courier",
    class: "txt_camelcase center_align"
  },
  {
    key: "cart",
    label: "Cart",
    class: "txt_camelcase center_align"
  },
  {
    key: "district",
    label: "District",
    class: "txt_camelcase center_align"
  },
  {
    key: "status",
    label: "Status",
    class: "txt_camelcase center_align"
  },
  {
    key: "dncn_printed_at",
    label: "DNCN Printed",
    class: "txt_camelcase center_align"
  },
  {
    key: "action",
    label: "Action"
  }
];

export default {
  name: "OrderMaster",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  mixins: [apiService],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      resultsLog: [], // [{ tn, status: 'success'|'duplicate'|'hardError'|'tempError', message, at }]
      submitQueue: [],           // local jobs: {tn, courier, addedAt, tries}
      isWorkerRunning: false,
      processedRecently: new Set(),  // to prevent immediate duplicates during a session
      lastRefreshAt: 0,
      refreshTimer: null,
      update_route_obj: {
        tracking_number: ""
      },
      tracking_route_options: [],
      search_tracking_route_options: [],
      sel_table_limit: this.TABLE_LIMIT,
      courier_options: [],
      cart_courier_options: [],
      client_options: [
        {
          value: null,
          text: "All Clients"
        }
      ],
      export_date: {
        start_at: moment()
          .subtract(7, "d")
          .format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD")
      },
      upload_file: [],
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      updating_item: false,
      export_criteria: {
        courier_selected: null,
        channel_selected: null
      },
      search_criteria: {
        keyword: "",
        courier_selected: null,
        client_selected: [],
        channel_selected: null,
        scheduled_delivery_date: moment().format("YYYY-MM-DD"),
        // start_at: moment().format("YYYY-MM-DD"),
        // end_at: moment()
        //   .add(1, "d")
        //   .format("YYYY-MM-DD"),
        order_status_selected: null,
        stock_status_selected: null,
        fulfilment_status_selected: null,
        cart_status_selected: null,
        tracking_status_selected: null,
        status_selected: null,
        route_selected: null,
        inout_warehouse: 'in-warehouse',
        show_history_record: 'show_by_date',
        dncn_status_selected: null
      },
      showAlert_success: false,
      alert_success_message: "",

      showAlert_error: false,
      alert_error_message: "",

      channel_options: [
        {
          value: null,
          text: "All Channel"
        }
      ],

      inout_warehouse_options: [
        {
          value: null,
          text: "In & Out of Warehouse"
        },
        {
          value: "in-warehouse",
          text: "In-Warehouse"
        },
        {
          value: "out-warehouse",
          text: "Out-of-Warehouse"
        },
      ],

      cart_status_options: [
        {
          value: null,
          text: "All Cart Status"
        },
        {
          value: "pending",
          text: "pending"
        },
        {
          value: "reserved",
          text: "reserved"
        },
        {
          value: "on_cart",
          text: "on_cart"
        },
        {
          value: "shipped",
          text: "shipped"
        }
      ],

      order_status_options: [
        {
          value: null,
          text: "All Order Status"
        },
        {
          value: "cancel",
          text: "Cancel"
        },
        {
          value: "received",
          text: "Received"
        },
        {
          value: "pending",
          text: "Pending"
        }
      ],
      stock_status_options: [
        {
          value: null,
          text: "All Stock Status"
        },
        {
          value: "-",
          text: "-"
        },
        {
          value: "pending",
          text: "Pending"
        },
        {
          value: "available",
          text: "Available"
        },
        {
          value: "committed",
          text: "Committed"
        }
      ],

      fulfilment_status_options: [
        {
          value: null,
          text: "All Fulfilment Status"
        },
        {
          value: "fulfiled",
          text: "Fulfilled"
        },
        {
          value: "pending",
          text: "Pending"
        }
      ],

      tracking_status_options: [
        {
          value: null,
          text: "All Status"
        },
        {
          value: "Pending",
          text: "Pending"
        },
        {
          value: "In_Transit",
          text: "In_Transit"
        },
        {
          value: "Successful",
          text: "Successful"
        },
        {
          value: "Cancelled",
          text: "Cancelled"
        },
        {
          value: "Shipped_Ext",
          text: "Shipped_Ext"
        },
        {
          value: "Returned_to_Warehouse",
          text: "Returned_to_Warehouse"
        },
        {
          value: "Rescheduled",
          text: "Rescheduled"
        },
        {
          value: "Unsuccessful_Delay",
          text: "Unsuccessful_Delay"
        },
        {
          value: "Unsuccessful_Other",
          text: "Unsuccessful_Other"
        },
        {
          value: "Unsuccessful_Reject",
          text: "Unsuccessful_Reject"
        },
        {
          value: "Hold",
          text: "Hold"
        },
        {
          value: "Unsuccessful_Unreach",
          text: "Unsuccessful_Unreach"
        },
        {
          value: "Ready_for_Fulfilment",
          text: "Ready_for_Fulfilment"
        },
        {
          value: "Ready_for_Shipment",
          text: "Ready_for_Shipment"
        },
        {
          value: "Ready_for_Redemption",
          text: "Ready_for_Redemption"
        },
        {
          value: "Redemption_Reserved",
          text: "Redemption_Reserved"
        },
        {
          value: "Redemption_Checked-In ",
          text: "Redemption_Checked-In "
        },
        {
          value: "Redemption_Expired",
          text: "Redemption_Expired"
        },
        {
          value: "Redemption_Checked-Out",
          text: "Redemption_Checked-Out"
        },
        {
          value: "Redemption_Collected",
          text: "Redemption_Collected"
        },
        {
          value: "Redemption_Autovoided",
          text: "Redemption_Autovoided"
        },
        {
          value: "Redemption_Returned",
          text: "Redemption_Returned"
        },
        {
          value: "Redemption_Abnormal",
          text: "Redemption_Abnormal"
        },
        {
          value: "Redemption_CancelledCustomer",
          text: "Redemption_CancelledCustomer"
        },
        {
          value: "Redemption_Cancelled",
          text: "Redemption_Cancelled"
        }
      ],
      history_record_option: [
        {
          value: 'show_by_date',
          text: 'Show By Date'
        },
        {
          value: 'show_history_record',
          text: 'Show History Record'
        }
      ],

      // tracking_status_options: [
      //   {
      //     value: null,
      //     text: "All Status"
      //   },
      //   {
      //     value: "Non-successful",
      //     text: "Non-successful"
      //   },
      //   {
      //     value: "processed",
      //     text: "Processed"
      //   },
      //   {
      //     value: "ready_for_shipment",
      //     text: "ready_for_shipment"
      //   },
      //   {
      //     value: "ready_for_fulfilment",
      //     text: "ready_for_fulfilment"
      //   },
      //   {
      //     value: "pending",
      //     text: "Pending"
      //   },
      //   {
      //     value: "in_transit",
      //     text: "In-Transit"
      //   },
      //   {
      //     value: "successful",
      //     text: "Successful Delivery"
      //   },
      //   {
      //     value: "shipped_at",
      //     text: "Shipped at"
      //   },
      //   {
      //     value: "returned_to_warehouse",
      //     text: "Returned to Warehouse"
      //   },
      //   {
      //     value: "return_to_warehouse",
      //     text: "Returning to Warehouse"
      //   },
      //   {
      //     value: "reschedule",
      //     text: "Reschedule"
      //   },
      //   {
      //     value: "unreach",
      //     text: "Unreach"
      //   },
      //   {
      //     value: "reject",
      //     text: "Reject"
      //   },
      //   {
      //     value: "delay",
      //     text: "Delay"
      //   },
      //   {
      //     value: "other",
      //     text: "Other"
      //   }
      // ],

      check_all_rows: false,
      outstanding_order_cnts: {},
      outstanding_stock_cnts: {},
      outstanding_fulfilment_cnts: {},
      bo_cnts: {},
      route_counts: {},
      route_ctns_counts: {},
      carton_cnt_checked: false,
      courier_groups: [],

      dncn_status_options: [
        {
          value: null,
          text: "All DNCN Status",
        },
        {
          value: "dncn_printed",
          text: "DNCN Printed",
        },
        {
          value: "dncn_not_printed",
          text: "DNCN NOT Printed",
        },
      ],
    };
  },
  computed: {
    lastResult() { return this.resultsLog[0] || null; },
    lastResultVariant() {
      if (!this.lastResult) return 'secondary';
      return this.lastResult.status === 'success' ? 'success'
        : this.lastResult.status === 'duplicate' ? 'warning'
          : 'danger';
    },
    lastResultText() {
      if (!this.lastResult) return '';
      const pfx = this.lastResult.status === 'success' ? 'OK'
        : this.lastResult.status === 'duplicate' ? 'Already'
          : 'Error';
      return `${pfx}: ${this.lastResult.tn}`;
    },
    recentResults() {
      return this.resultsLog.slice(0, 5);
    }
  },

  async created() {
    await this.getCouriers();
    // Start a light periodic refresh (no heavy reloads per scan)
    this.getRouteAllocations();

    let routes_response = await this.getTrackingRoutes(
      this.$store.state.user_obj
    );

    this.search_tracking_route_options.push({
      value: null,
      text: "All Routes"
    });

    this.tracking_route_options.push({
      value: null,
      text: "-"
    });
    for (let i in routes_response.tracking_routes) {
      this.tracking_route_options.push({
        value: routes_response.tracking_routes[i].route_name,
        text: routes_response.tracking_routes[i].route_name
      });

      this.search_tracking_route_options.push({
        value: routes_response.tracking_routes[i].route_name,
        text: routes_response.tracking_routes[i].route_name
      });
    }

    let clients_response = await this.getClients_old(
      this.$store.state.user_obj
    );
    for (let i in clients_response.clients) {
      this.client_options.push({
        value: clients_response.clients[i].name,
        text:
          clients_response.clients[i].full_name +
          " (" +
          clients_response.clients[i].name +
          ")"
      });
    }

    this.initialized = true;
  },
  mounted() {
    // this.loader = this.$loading.show({
    //   isFullPage: true,
    //   canCancel: false
    // });
  },
  watch: {
    // whenever changes, this function will run
    check_all_rows: function (new_val, old_val) {
      // this.check_all_rows = !this.check_all_rows;
      console.log("check_all_rows");
      if (new_val == "all") {
        // Check all
        for (let i in this.items) {
          this.items[i].is_checked = true;
        }
      } else {
        for (let i in this.items) {
          this.items[i].is_checked = false;
        }
      }
      console.log(this.items);
    }
  },
  methods: {
    addResultLog(entry) {
      this.resultsLog.unshift({ ...entry, at: Date.now() });
      if (this.resultsLog.length > 5) this.resultsLog.length = 5;
    },
    notifyToast(variant, msg) {
      this.$eventHub.$emit("show_alert_message", { alert_message: msg, variant });
    },
    notifyModal(msg) {
      this.$eventHub.$emit("show_modal_message", { message_content: msg });
    },
    classifyAxiosError(err) {
      // Axios-style error classification
      if (err && err.response) {
        const s = err.response.status;
        const msg = (err.response.data && (err.response.data.message || err.response.data.error)) || `HTTP ${s}`;
        if (s === 409) return { type: 'duplicate', message: msg };       // idempotent/duplicate
        if (s === 422 || s === 400) return { type: 'hard', message: msg }; // validation/business rule
        if (s >= 500) return { type: 'temp', message: msg };             // server hiccup (retryable)
        return { type: 'hard', message: msg };
      } else if (err && (err.code === 'ECONNABORTED' || /timeout/i.test(err.message))) {
        return { type: 'temp', message: 'Request timeout' };
      }
      return { type: 'temp', message: 'Network error' };
    },
    isBusinessSuccess(res) {
      // Treat any of these as success to keep scanning fast
      if (!res) return true;
      if (res.status === 204) return true;
      if (res.data && (res.data.status === 'success' || res.data.ok === true)) return true;
      // If your API marks "already assigned" specially, consider that a soft success too.
      if (res.data && (res.data.code === 'ALREADY_ASSIGNED' || res.data.status === 'duplicate')) return 'duplicate';
      return false;
    },
    focusScanner() {
      // keep scanner input focused after each event
      this.$nextTick(() => this.$refs.txt_order_number && this.$refs.txt_order_number.focus());
    },
    enqueueSubmit(tn, courier) {
      if (!tn) return;

      // avoid rapid duplicates
      const dedupeKey = `${courier || ''}|${tn}`;
      if (this.processedRecently.has(dedupeKey) || this.submitQueue.find(j => j.tn === tn && j.courier === courier)) {
        this.$eventHub.$emit("show_alert_message", { alert_message: "Already in queue", variant: "info" });
        return;
      }

      this.submitQueue.push({ tn, courier, addedAt: Date.now(), tries: 0 });
      this.processedRecently.add(dedupeKey);

      // keep recent set bounded
      if (this.processedRecently.size > 500) {
        this.processedRecently = new Set([...this.processedRecently].slice(-300));
      }

      // kick worker if idle
      if (!this.isWorkerRunning) this.processQueue();
    },

    async processQueue() {
      if (this.isWorkerRunning) return;
      this.isWorkerRunning = true;

      while (this.submitQueue.length) {
        const job = this.submitQueue[0];

        try {
          const res = await this.$http({
            method: "POST",
            baseURL: `${this.API_HOST}`,
            url: "external_route_allocation_set.php",
            data: {
              // send minimal payload to keep it fast
              tracking_number: job.tn,
              courier: job.courier,
              client_id: this.$store.state.user_obj.client_id,
              user_id: this.$store.state.user_obj.user_id
            },
            timeout: 5000
          });

          const ok = this.isBusinessSuccess(res);
          if (ok === true) {
            this.addResultLog({ tn: job.tn, status: 'success', message: 'Added' });
            this.notifyToast('success', `Added ${job.tn}`);
            this.submitQueue.shift();
          } else if (ok === 'duplicate') {
            this.addResultLog({ tn: job.tn, status: 'duplicate', message: 'Already assigned' });
            this.notifyToast('warning', `${job.tn} already assigned`);
            this.submitQueue.shift();
          } else {
            // HTTP 200 but business error in body
            const msg = (res.data && (res.data.message || res.data.error)) || 'Unknown error';
            this.addResultLog({ tn: job.tn, status: 'hardError', message: msg });
            this.notifyModal(`Failed to add ${job.tn}: ${msg}`);
            this.submitQueue.shift(); // do not retry business-rule failures
          }

          this.getRouteAllocations();

        } catch (err) {
          const { type, message } = this.classifyAxiosError(err);
          if (type === 'temp') {
            job.tries += 1;
            if (job.tries < 3) {
              const delay = [700, 1500][job.tries - 1] || 2000;
              await new Promise(r => setTimeout(r, delay));
              continue; // retry this same job
            }
            this.addResultLog({ tn: job.tn, status: 'tempError', message });
            this.notifyToast('danger', `Network issue on ${job.tn}: ${message}`);
            this.submitQueue.shift(); // give up after retries
          } else if (type === 'duplicate') {
            this.addResultLog({ tn: job.tn, status: 'duplicate', message: message || 'Already assigned' });
            this.notifyToast('warning', `${job.tn} already assigned`);
            this.submitQueue.shift();
          } else {
            // hard validation/business error
            this.addResultLog({ tn: job.tn, status: 'hardError', message });
            this.notifyModal(`Failed to add ${job.tn}: ${message}`);
            this.submitQueue.shift();
          }
        }

        this.focusScanner();
      }

      this.isWorkerRunning = false;
    },

    // replace the original immediate-submit with enqueue
    async updateRoute() {
      const tn = (this.update_route_obj.tracking_number || "").trim();
      const courier = this.update_route_obj.courier || null;
      if (!tn) return;
      this.update_route_obj.tracking_number = "";  // clear instantly
      this.enqueueSubmit(tn, courier);
      this.focusScanner();
    },

    displayDate(d) {
      if (d == '0000-00-00') {
        return "-";
      } else if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "-";
      }
    },

    async _updateRoute() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "external_route_allocation_set.php",
        data: {
          search_criteria: this.search_criteria,
          tracking_number: this.update_route_obj.tracking_number,
          courier: this.update_route_obj.courier,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      if (response.data.status == "success") {
        this.$eventHub.$emit("show_alert_message", {
          alert_message: "Tracking Route Updated",
          variant: "success"
        });
        if (response.data.message && response.data.message != "") {
          this.$eventHub.$emit("show_modal_message", {
            message_content: response.data.message
          });
        }

        this.update_route_obj.tracking_number = null;
      } else {
        this.$eventHub.$emit("show_modal_message", {
          message_content: response.data.message
        });
      }

      this.loader.hide();
      this.getRouteAllocations();
    },

    async removeRoute() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "route_allocation_remove.php",
        data: {
          tracking_number: this.update_route_obj.tracking_number,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      if (response.data.status == "success") {
        this.$eventHub.$emit("show_alert_message", {
          alert_message: "Tracking Route Updated",
          variant: "success"
        });
        if (response.data.message && response.data.message != "") {
          this.$eventHub.$emit("show_modal_message", {
            message_content: response.data.message
          });
        }

        this.update_route_obj.tracking_number = null;
      } else {
        this.$eventHub.$emit("show_modal_message", {
          message_content: response.data.message
        });
      }

      this.loader.hide();
      this.getRouteAllocations();
    },

    async cancelRoute(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "route_allocation_cancel.php",
        data: {
          tracking_number: row_data.tracking_number,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success"
      });
      this.getRouteAllocations();
    },

    async onSearchByRoute(cart_status, route) {
      this.search_criteria["status_selected"] = cart_status;
      this.search_criteria["route_selected"] = route;
      this.getRouteAllocations();
    },

    async onSearchByCourier(cart_status, courier) {
      this.search_criteria["cart_status_selected"] = cart_status;
      this.search_criteria["courier_selected"] = courier;
      this.getRouteAllocations();
    },

    async getRouteAllocations() {
      // this.loader = this.$loading.show({
      //   isFullPage: true,
      //   canCancel: false
      // });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "external_route_allocation_get.php",
        data: {
          offset: this.table_offset,
          limit: this.sel_table_limit,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.items = response.data.trackings;
      this.total_rows = parseInt(response.data.total_rows);

      let courier_groups = response.data.courier_groups || [];
      let tmp_courier_counts = response.data.courier_counts;
      let tmp_route_ctns_counts = response.data.courier_ctns_counts;
      let route_counts = {};
      let route_ctns_counts = {}
      Object.keys(tmp_courier_counts).forEach(courier_short_name => {
        let group = courier_groups.find(g => g.courier_short_name === courier_short_name);
        let group_no = group ? group.group_no : 9999;
        if (!route_counts[group_no]) {
          route_counts[group_no] = {};
        }
        route_counts[group_no][courier_short_name] = tmp_courier_counts[courier_short_name];
      })
      Object.keys(tmp_route_ctns_counts).forEach(courier_short_name => {
        let group = courier_groups.find(g => g.courier_short_name === courier_short_name);
        let group_no = group ? group.group_no : 9999;
        if (!route_ctns_counts[group_no]) {
          route_ctns_counts[group_no] = {};
        }
        route_ctns_counts[group_no][courier_short_name] = tmp_route_ctns_counts[courier_short_name];
      })

      console.log(route_counts)

      //   this.route_counts = response.data.courier_counts;
      //   this.route_ctns_counts = response.data.courier_ctns_counts;

      this.route_counts = route_counts;
      this.route_ctns_counts = route_ctns_counts;

      // this.loader.hide();
    },

    onSearch() {
      for (const key in this.search_criteria) {
        if (typeof this.search_criteria[key] === "string") {
          this.search_criteria[key] = this.search_criteria[key].trim();
        }
      }
      this.getRouteAllocations();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.sel_table_limit;
      this.getRouteAllocations();
    },

    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.is_checked) return "table-info";
    },

    async onBulkAction(bulk_action) {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let tracking_ids = [];
      for (let i in this.items) {
        if (this.items[i].is_checked) {
          tracking_ids.push(this.items[i].id);
        }
      }

      // call action
      let action_urls = {
        receive: "tracking_receive.php",
        commit: "tracking_commit.php",
        fulfill: "tracking_fulfil.php"
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "external_route_reserve.php",
        data: {
          search_criteria: this.search_criteria,
          tracking_ids: tracking_ids,
          client_id: this.$store.state.user_obj.client_id,
          status_to_update: bulk_action,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.loader.hide();
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Bulk Update Success",
        variant: "success"
      });
      this.getRouteAllocations();
    },
    async onBulkShippedExt(bulk_action) {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let tracking_ids = [];
      for (let i in this.items) {
        if (this.items[i].is_checked) {
          tracking_ids.push(this.items[i].id);
        }
      }

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "route_shipped_ext.php",
        data: {
          tracking_ids: tracking_ids,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.loader.hide();
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Bulk Update Success",
        variant: "success"
      });
      this.getRouteAllocations();
    },
    async getCouriers() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "couriers_get.php",
        data: {}
      });

      this.courier_options = [
        {
          value: null,
          text: "All Couriers"
        }
      ];

      this.cart_courier_options = [
        {
          value: null,
          text: "-"
        }
      ]

      for (let i in response.data.couriers) {
        if (response.data.couriers[i].ext_route_allocation == 0) {
          continue;
        }
        let courier_obj = {
          value: response.data.couriers[i].short_name,
          text: response.data.couriers[i].long_name
        };

        this.courier_options.push(courier_obj);
        this.cart_courier_options.push(courier_obj)
      }
    },
    onChangeShowHistoryRecord(val) {
      if (val === 'show_history_record') {
        this.search_criteria.scheduled_delivery_date = ""
      }
    },
    async bulkDownloadDNCN() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let checked_items = [];
      let waybill_tracking_number = "";

      for (let i in this.items) {
        let item_tmp = this.items[i];
        if (
          item_tmp.is_checked &&
          item_tmp.tracking_number &&
          item_tmp.tracking_number != ""
        ) {
          waybill_tracking_number = item_tmp.tracking_number;
          checked_items.push(item_tmp.id);
        }
      }

      this.$http({
        url: process.env.NODEJS_API_URL_PDF + "/printExtPacking",
        method: "POST",
        data: {
          tracking_ids: checked_items,
          user_id: this.$store.state.user_obj.user_id,
        },
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "GOLS_DNCN.pdf");
        document.body.appendChild(link);
        link.click();
        this.loader_full.hide();
      });
    },
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.span-status {
  display: none;
}

.container-status:hover .span-status {
  display: inline;
}

.row-status_cnt {
  display: flex;
}

.route_box {
  border: 1px solid #cacaca;
  border-radius: 2px;
  padding: 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ExternalRouteAllocation.vue